// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueI18n from "vue-i18n";
import Buefy from "buefy";
import { store } from "./store/store";
import App from "./App";
import router from "./router";
import VueLocalStorage from "vue-localstorage";
import VueAuth from "@websanova/vue-auth";
import VueResource from "vue-resource";
import VuejsDialog from "vuejs-dialog";
import VueAnalytics from "vue-analytics";
import FBSignInButton from 'vue-facebook-signin-button'
import VueMoment from "vue-moment";
import moment from "moment";
import _ from "lodash";
// import Trend from 'vuetrend';

import VueCookie from "vue-cookie";
import VueYoutube from 'vue-youtube'


import "vue2-dropzone/dist/vue2Dropzone.css";
// import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
// import VueVirtualScroller from "vue-virtual-scroller";

import BasicMenu from "./components/BasicMenu";
import FrontMenu from "./components/FrontMenu";

console.log(process.env.NODE_ENV);
var mixpanel;
// if (
//   process.env.NODE_ENV === "production"
// ) {
//   mixpanel = require('mixpanel-browser');
//   mixpanel.init('9fcccd984ead87cf8d5b9b6fc4109eb1');
// } else {
  mixpanel = {
    alias: _.noop,
    identify: _.noop,
    track: _.noop,
    people: {
      set: _.noop,
      increment: _.noop
    }
  }
// }

Vue.prototype.$mixpanel = mixpanel;

Vue.set(Vue.prototype, '_', _);

// Vue.use(VueVirtualScroller);

Vue.use(VueCookie);

Vue.use(VueYoutube);

Vue.use(FBSignInButton)
// export const SocketInstance = socketio('http://localhost:8081');
// Vue.use(VeSocketIO, 'http://localhost:8081', store)
Vue.use(VueResource);

Vue.router = router;
Vue.use(VueAuth, {
  auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/vue-resource.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js")
});
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'

// SET UP TRACKING

if (process.env.NODE_ENV !== 'development') {
Vue.use(VueAnalytics, {
  id: "UA-915791-15",
  checkDuplicatedScript: true,
  beforeFirstHit() {
    Vue.$ga.set("anonymizeIp", true);
  },
  autoTracking: {
    exception: true
  },
  batch: {
    enabled: true,
    amount: 5,
    delay: 2000
  },
  commands: {
    // listenToTeacher() {
    //   this.$ga.event("sentences", "listen", "teacher", 1);
    // },
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === "production"
  },
  router
});
}

Vue.use(require("vue-shortkey"), { prevent: ["input", "textarea"] });
Vue.use(VueMoment, {
  moment
});
Vue.use(Buefy);
// Vue.use(Trend);
Vue.use(VuejsDialog, {
  html: true,
  okText: "Continue",
  cancelText: "Cancel"
});
Vue.use(VueI18n);
Vue.use(VueLocalStorage);
Vue.config.productionTip = false;

Vue.component("basic-menu", BasicMenu);
Vue.component("front-menu", FrontMenu);

window.Vue = Vue;

// Authorization

Vue.http.interceptors.push(function(request, next) {
  next(function(res) {
    // Unauthorized Access

    if (
      res.status === 401 &&
      ["UnauthorizedAccess", "InvalidToken"].indexOf(res.data.code) > -1
    ) {
      Vue.auth.logout({
        redirect: { name: "SignIn" }
      });
    }

    // System Error
    else if (res.status === 500) {
      Vue.router.push({ name: "Error500" });
    }
  });
});

Vue.filter('bold', function(words, query) {
  return words.replace(query, '<b>' + query + '</b>')
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js